<script>
  import { onMount, onDestroy } from 'svelte'
  import { fmtDate, statusColor } from './utils'
  import { conditionMonitoringAPI } from './api.js'
  import { Button, TextField } from 'smelte'
  import FasIcon from 'fa-svelte'
  import { faInfoCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
  import { protocol } from './store'
  import { push, pop, querystring } from 'svelte-spa-router'
  import DataTable from '../DataTable/DataTable.svelte'
  import Snackbar from 'smelte/src/components/Snackbar'
  import CheckboxGroup from './CheckboxGroup.svelte'
  import Select from 'smelte/src/components/Select'
  import { parseQuery } from '../InstallBase/urlQuery'
  import { selectedInstalledBase } from '../../store'
  import { fade } from 'svelte/transition'
  import Tracker from '../../tracking'

  export let params = {}

  let dataPromise

  const api = new conditionMonitoringAPI()
  const fmt1 = '[0-9]([,\.][0-9]+)?'
  const fmt2 = '[0-9]+'
  const cache = {chain: ''}
  let upgrades = [
    {label: 'Slide rail', value: 'Slide rail'},
    {label: 'Drive unit guides', value: 'Drive unit guides'},
    {label: 'Drive wheel', value: 'Drive wheel'},
    {label: 'Chain', value: 'Chain'},
  ]
  const statusText = {
    10: 'Maintenance and Spare parts are required. Contact your local FlexLink office for further information.',
    20: 'Maintenance and Spare parts are required imminently. Contact your local FlexLink office for further information.',
    30: 'From the measurements taken it appears that maintenance is not required at this time. However in order to ' +
      'keep your equipment in the optimum condition we recommend you to request ' +
      'an audit from your local FlexLink office.'
  }
  const statusCodeMap = {
    0: 'undefined',
    10: 'critical',
    20: 'warning',
    30: 'good'
  }

  let details = {what_upgraded: []}
  let machine = {}
  let saving = false
  let wasSaved = false
  let installedBase = []
  let instructionVisible = null
  let snackbar = {show: false, message: '', color: ''}

  let _measurementsView = []
  let measurementsViewTemplate = []
  $: measurementsView = calcMeasurementsView(_measurementsView, details.chain)
  $: incorrectValues = measurementsView.some(m => m.error || m.value < 0.0001)

  $: status = Math.min(...measurementsView.map(m => m.status))
  $: setProtocolStatus(status)

  let chainsMap = {}
  $: chains = chainsMap[$protocol.ProductGroup] ? chainsMap[$protocol.ProductGroup].map(p => ({value: p, text: p})) : []
  $: if (chains.length > 0 && (details.chain == null || details.chain === '')) {
    details.chain = chains[0].value
  }

  $: isNew = params.id === 'new'
  $: isMachineSelected = params.id != null && params.id !== 'new' || $protocol.machine_no != null

  let filter = []
  let columns = [
    {label: 'ID', field: 'no', add: '', w: '40', iconAfter: true},
    {label: 'Machine model / Product group', field: 'ProductGroup', add: '', w: '40', iconAfter: true},
    {label: 'Project number', field: 'project_no', add: '', w: '40', iconAfter: true},
    {label: 'Serial', field: 'sn', add: '', w: '40', iconAfter: true},
    {label: 'Unit serial', field: 'unit_serial', add: '', w: '40', iconAfter: true},
  ]
  let delayTimer

  onDestroy(() => {
    $selectedInstalledBase = {no: null}
  })

  onMount(async () => {

    api.getChains().then(res => {
      chainsMap = res.data || {}
    })
    const tracker = new Tracker()
    if (isNew) {
      tracker.track('condition_monitoring.Create_protocol')
      // noinspection ES6MissingAwait
      initNewProtocol()
      return
    }
    tracker.track('condition_monitoring.Open_protocol')
    // noinspection ES6MissingAwait
    initExistingProtocol()
  })

  async function initNewProtocol() {
    let queryObj = parseQuery($querystring)
    if (queryObj.machine_no != null) {
      //if (isMachineSelected) {
      $protocol.machine_no = queryObj.machine_no
      console.log('[DEBUG] machine_no', $protocol.machine_no)
      machineSelectHandler({detail: $selectedInstalledBase})
      return
    }
    const FIRST_BATCH_LIMIT = 100
    const MAX_ROWS_LIMIT = 100000
    dataPromise = api.getInstalledBaseList(FIRST_BATCH_LIMIT)
            .then(res => {
              installedBase = res.data
              dataPromise = api.getInstalledBaseList(MAX_ROWS_LIMIT)
                      .then(res => {
                        if (res.data != null && Array.isArray(res.data)) {
                          installedBase = [...installedBase, ...res.data.slice(FIRST_BATCH_LIMIT)]
                        }
                      })
            })
            .catch(err => {
              console.log('[ERROR]', err)
            })
  }

  $: {
    getState($querystring)
  }

  function getState(){
    let queryObj = parseQuery($querystring)
    if (queryObj.machine_no != null) {
      filter = [{field: 'machine_no', value: queryObj.machine_no}]
      const i = columns.findIndex(p => p.field === 'machine_no')
      if (i > -1) {
        columns[i].filter = queryObj.machine_no
      }
    }else if (queryObj.project != null){
      console.log('[DEBUG] project_no', queryObj.project)
      filter = [{field: 'project_no', value: queryObj.project.toLowerCase()}]
      const i = columns.findIndex(p => p.field === 'project_no')
      if (i > -1) {
        columns[i].filter = queryObj.project
      }
    }
  }

  async function initExistingProtocol () {
    if ($protocol._id == null || $protocol._id !== params.id) {
      console.log('[DEBUG] fetch protocol, id:', params.id)
      const res = await api.getOneProtocol(params.id)
        .catch(err => {
          console.log('[ERROR]', err)
        })
      $protocol = res.data
    }
    details = $protocol
    console.log('[DEBUG] protocol', $protocol)

    // noinspection ES6MissingAwait
    getMeasurementsView(params.id)
  }

  function calcMeasurementsView () {
    // console.log('[DEBUG] _measurementsView', _measurementsView)
    const a = [..._measurementsView.filter(p => p.chain == null || p.chain === '' || p.chain === details.chain)]
    const b = [...measurementsViewTemplate.filter(q =>
      _measurementsView.findIndex(r => r.param_id === q.param_id) < 0 &&
      (q.chain == null || q.chain === '' || q.chain === details.chain)
    )]
    return [...a, ...b].sort((a, b) => {
      return a.name < b.name ? -1 : 1
    })
  }

  function setProtocolStatus (status) {
    details.status = status
    details.status_code = statusCodeMap[status]
  }

  function decodeValues (measurementsView) {
    const list = JSON.parse(JSON.stringify(measurementsView))
    list.forEach(m => {
      m.value = m.value / 1000
      m.limits.forEach(l => {
        l.value = l.value / 1000
      })
    })
    return list
  }

  function encodeValues (measurementsView) {
    const list = JSON.parse(JSON.stringify(measurementsView))
    list.forEach(m => {
      m.value = Math.floor(m.value * 1000 + 0.5)
      m.limits.forEach(l => {
        l.value = Math.floor(l.value * 1000 + 0.5)
      })
    })
    return list
  }

  async function getMeasurementsView (protocolID) {
    if (protocolID === 'new') {
      return
    }
    await api.getMeasurementViewList(protocolID)
      .then(res => {
        _measurementsView = decodeValues(res.data)
        setTimeout(() => {
          const editFields = [...document.getElementsByClassName('decimal')]
          editFields.forEach(f => {
            f.value = parseFloat(f.value).toFixed(1)
          })

          checkAllLimits()
        }, 10)
        // console.log('[DEBUG] _measurementsView', _measurementsView)
      })
  }

  async function saveHandler () {
    saving = true
    setTimeout(() => {
      saving = false
    }, 1000)

    const data = JSON.parse(JSON.stringify(details))
    data.measurements = encodeValues(measurementsView)
    console.log('[DEBUG] data', data)
    try {
      if (!isNew) {
        api.saveProtocol(data)
          .then(res => {
            // console.log('[DEBUG] save response', res.data)
            snack('success', 'Saved successfully.')
            details.modified = res.data
            details.status = status
            wasSaved = true
          })
          .catch(err => {
            snack('error', 'Something went wrong.')
            console.log('[ERROR] save response', err)
          })
      }
      if (isNew) {
        api.createProtocol(data)
          .then(res => {
            // console.log('[DEBUG] create response', res.data)
            snack('success', 'Saved successfully.')
            params.id = res.data
            details._id = res.data
            details.modified = new Date().toISOString() // res.data
            details.status = status
            wasSaved = true
          })
          .catch(err => {
            snack('error', 'Something went wrong.')
            console.log('[ERROR]', err)
          })
      }
    } catch (err) {
      console.log('[ERROR]', err)
    }
    // details.measurements = decodeValues(measurementsView)
    // details.status = status
  }

  function inputHandler (elem, m) {
    m.error = ''
    clearTimeout(delayTimer)
    delayTimer = setTimeout(() => {
      elem.target.value = parseFloat(elem.target.value).toFixed(1).toString()
    }, 100)
    m.status = getStatus(m)
    _measurementsView = [..._measurementsView]
    const err = checkLimits(elem.target.value, m)
    if (err != null) {
      m.error = err
    }
  }

  function checkAllLimits () {
    _measurementsView.forEach((m, i) => {
      const err = checkLimits(m.value, m)
      if (err != null) {
        _measurementsView[i].error = err
      }
      _measurementsView = [..._measurementsView]
    })
  }

  function checkLimits (v, m) {
    const limit1 = m.limits[0].value
    const limit2 = m.limits[m.limits.length - 1].value
    const sign = Math.sign(limit2 - limit1)
    const worstValue = limit2 + sign * Math.abs(limit2 - limit1) * 1
    const value = parseFloat(v)

    if (value * sign < limit1 * sign || value * sign > worstValue * sign) {
      return 'Value out of range'
    }

    console.log('[DEBUG] m', m)
    return null
  }

  function getStatus (measurement) {
    let before = (a, b) => {
      return false
    }
    if (measurement.func === 'lower_bound') {
      before = (a, b) => {
        return a > b
      }
    } else if (measurement.func === 'upper_bound') {
      before = (a, b) => {
        return a < b
      }
    }
    const limits = measurement.limits.map(l => l.value)
    // console.log('[DEBUG]', ...limits)
    // incorrect value
    if (before(measurement.value, 2 * limits[0] - limits[2])) {
      return 0
    }
    // behind all limits
    if (!before(measurement.value, limits[2])) {
      return 10
    }
    // green
    if (before(measurement.value, limits[1])) {
      return 30
    }
    // yellow
    if (before(measurement.value, limits[2])) {
      return 20
    }
    // red
    return 10
  }

  function fallback (value) {
    return value == null ? '-' : value
  }

  function getMeasurementsViewTemplate (productGroup, resolver) {
    api.getMeasurementViewTemplate(productGroup)
      .then(res => {
        const view = decodeValues(res.data)
        view.sort((a, b) => {
          return a.name < b.name ? -1 : 1
        })
        // console.log('[DEBUG] template view', view)
        resolver(view)
      })
      .catch(err => {
        console.log('[ERROR]', err)
      })
  }

  function machineSelectHandler ({detail}) {
    details.project_id = detail.project_id
    api.getOneProtocolTemplate(detail.no)
      .then(res => {
        details = res.data
        details._id = null
        $protocol = details
        getMeasurementsViewTemplate($protocol.ProductGroup, view => {
          _measurementsView = view
        })
      })
      .catch(err => {
        console.log('[ERROR]', err)
      })
  }

  function showInstruction (imageFilename) {
    console.log('[DEBUG] show instruction', imageFilename)
    if (imageFilename == null || imageFilename.length < 1) {
      return
    }
    instructionVisible = imageFilename
  }

  function getRedirectLink () {
    const url = api.getURL('/ib/api/v1/redirect/flexlink-in-the-world')
    return `<a href="${url}" target="_blank" class="text-red-500 hover:underline">
      FlexLink office
    </a>`
  }

  function snack (color, message) {
    snackbar.message = message
    snackbar.color = color
    snackbar.show = true
  }
</script>

<div class="relative">
  {#if instructionVisible != null}
    <div class="absolute bg-white border border-gray-300 shadow-xl z-20"
         style="height: 600px; width: 800px; top: -20px; left: 50%; transform: translate(-50%, 0);">
      <img src={'/static/uploaded/cm-instructions/' + instructionVisible}
           alt={'measurement instruction: ' + instructionVisible}>

      <div class="absolute uppercase flex items-center btn" style="top: 2rem; right: 2.2rem"
           on:click={() => { instructionVisible = null }}>
        <i class="material-icons icon ml-2 close-icon cursor-pointer">close</i>
      </div>
    </div>
  {/if}

  <div class="container mx-auto px-8 pt-1 pb-1 bg-white">
    <div class="flex header bg-white my-12">
      <div class="text-xl text-black ">CONVEYOR MEASUREMENT PROTOCOL</div>
    </div>

    {#if isMachineSelected}
      <div in:fade class="w-full flex">
        <div class="w-1/2 text-left text-lg text-gray-700 pr-6">

          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Select conveyor's chain / belt</div>
            <div class="w-1/2 h-full pb-5 bg-gray-200 text-value">
              <Select placeholder="select conveyor chain"
                      listClasses="overflow-x-auto overflow-y-auto"
                      noUnderline dense
                      items={chains}
                      bind:value={details.chain}
                      remove="pt-4" add="pt-2 text-gray-700 bg-gray-200"
              />
            </div>
          </div>

          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Installed Base No.</div>
            <div class="w-1/2 text-value">
              {fallback(details.machine_no)}
            </div>
          </div>
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Project number</div>
            <div class="w-1/2 text-value">{fallback(details.su_erp_proj)}</div>
          </div>
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Customer</div>
            <div class="w-1/2 text-value">{fallback(details.eu_name)}</div>
          </div>
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Platform</div>
            <div class="w-1/2 text-value">{fallback(details.machine_model)}</div>
          </div>
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Machine model / Product group</div>
            <div class="w-1/2 text-value">{fallback(details.ProductGroup)}</div>
          </div>
          <!--
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Chain</div>
            <div class="w-1/2 text-value flex text-base">
              <RadioButtonGroup items={chains} />
            </div>
          </div>
          -->
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Submitted date</div>
            <div class="w-1/2 text-value">{fallback(fmtDate(details.modified))}</div>
          </div>
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">User</div>
            <div class="w-1/2 text-value">{fallback(details.username)}</div>
          </div>
          <!--
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Startup date</div>
            <div class="w-1/2 text-value">{machine.startup}</div>
          </div>
          -->
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Estimated running hours since startup</div>

            <div class="w-1/2 h-full">
              <input class="px-3 bg-gray-200 h-full w-full text-left focus:bg-gray-300 edit"
                     pattern={fmt2} step="1" max="999999"
                     type=number placeholder="0" min=0
                     bind:value={details.hours}
              />
            </div>
          </div>
          <div class="row flex h-12 border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Estimated running hours since last maintenance</div>

            <div class="w-1/2 h-full">
              <input class="px-3 bg-gray-200 h-full w-full text-left focus:bg-gray-300 edit"
                     pattern={fmt2} step="1" max="999999"
                     type=number placeholder="0" min=0
                     bind:value={details.hours_upgraded}
              />
            </div>

          </div>
          <div class="row flex border-b border-gray-400 items-center">
            <div class="w-1/2 text-base label">Select the parts changed at last maintenance:</div>

            <div class="w-1/2 h-full text-base flex flex-wrap items-center pt-2">
              <CheckboxGroup add="lg:w-1/2"
                             bind:items={upgrades}
                             bind:group={details.what_upgraded} />
            </div>

          </div>
        </div>

        <div class="w-1/2 text-lg text-left">


          <div class="h-12 bg-gray-600 text-white text-base py-3 flex items-center">
            <div class="pl-5 flex-grow">Measurements</div>
            <div class="pl-2 w-10">&nbsp;</div>
            <div class="pl-2 w-48">Measured Value (mm)</div>
            <!--
            <div class="w-20 text-center">Status</div>
            -->
          </div>
          {#each measurementsView as m}
            <div class="flex h-12 text-gray-700 border-b border-gray-400 flex items-center">
              <div class="pl-1 text-base font-medium flex-grow">{m.name}</div>
              <div class="px-2 w-10 text-center text-gray-500 cursor-pointer"
                   on:click={() => { showInstruction(m.instruction) }}>
                <FasIcon icon={faInfoCircle} />
              </div>
              <div class="w-48 h-full relative">
                <input class="block px-3 bg-gray-200 h-full w-full text-right focus:bg-gray-300 edit decimal"
                       pattern={fmt1} step="0.1" max="9999"
                       type=number placeholder="0.0" min=0
                       bind:value={m.value}
                       on:blur={(elem) => { inputHandler(elem, m) }}
                />
                <div class={m.error ? 'absolute top-0 h-12' : 'hidden'}>
                  <div class="flex items-center h-full pl-3 text-alert-500 alert">
                    <FasIcon icon={faExclamationTriangle} />
                    <div class="alert-text bg-alert-500 text-white rounded-md elevation-3 items-center justify-center">
                      {m.error}
                    </div>
                  </div>
                </div>
                <!--
                <div class="absolute w-full bottom-0 text-sm text-red-500 px-3 pb-1 text-center">{m.error ? m.error : ''}</div>
                -->
              </div>
              <!--
              <div class="w-20 text-center">
                <div class="inline-block rounded-full bg-gray-600 w-5 h-5"
                     style={`background-color: ${statusColor(m.status)}`}>&nbsp;
                </div>
              </div>
              -->
            </div>
          {/each}
          {#if measurementsView.length < 1}
            <div class="py-8 px-10 text-xl font-light text-gray-400 text-center">
              No measurement parameters defined for this platform
            </div>
            <div class="text-red-500 hover:underline text-base text-center"
                 on:click={() => { push('/condition-monitoring/params') }}>Go to parameters
            </div>
          {/if}

          {#if !incorrectValues && (wasSaved || !isNew)}
            <div class="row flex border border-gray-400 h-36 items-center mt-12 px-4">
              <div class="text-gray-700 text-base label mr-8">Status</div>
              <div class="text-value flex items-center py-2">
                <div class="rounded-full bg-gray-600 w-8 h-8 mr-3 flex-shrink-0 border border-gray-300"
                     style={`background-color: ${statusColor(details.status_code)}`}>&nbsp;
                </div>
                <div class="text-base leading-relaxed">
                  {#if statusText[details.status]}
                    {@html statusText[details.status].replace('FlexLink office', getRedirectLink())}
                  {:else}
                    Not defined
                  {/if}
                </div>
              </div>
            </div>
          {/if}

        </div>
      </div>

      <div class="mt-8 mb-5">
        <Button text color="red" disabled={saving || incorrectValues} on:click={saveHandler}>
          {isNew && !wasSaved ? "SUBMIT" : "SAVE"}
        </Button>
        <Button text color="red" on:click={() => { pop() }}>GO Back</Button>
      </div>

    {:else}
      <div class="px-10 pb-6 text-lg text-gray-800 font-light">Please select installed base</div>

      <div class="text-gray-700" style="">
        <DataTable columns={columns} data={installedBase}
                   {dataPromise}
                   selectable={false}
                   current={-1}
                   activationColumn={0}
                   minWidth={600}
                   bind:filter={filter}
                   on:dblclick={machineSelectHandler}
        />
      </div>
      <div class="mt-8 mb-5">
        <Button text color="red" on:click={() => { pop() }}>GO Back</Button>
      </div>
    {/if}

  </div>

  <Snackbar bind:value={snackbar.show}
            bind:color={snackbar.color}
            timeout={2000}>
    <div>{snackbar.message}</div>
  </Snackbar>

</div>

<style>
    .edit {

    }

    .edit:focus {
        color: black;
    }

    .close-icon {
        color: #a0a0a0;
        font-size: 2.5rem;
    }

    .close-icon:hover {
        color: #1d1d1d;
    }

    .alert .alert-text {
        display: none;
        text-align: center;
        padding: 0.3rem 0.5rem;
        position: absolute;
        right: 1.5rem;
        top: -0.7rem;
        min-width: 15rem;
    }

    .alert:hover .alert-text {
        display: block;
    }
</style>